class LicenseInfoService {
  loadWeeks(id) {
    return $.post(loadWeeksUrl, { id });
  }
}

module.exports = LicenseInfoService;
